import React from "react";
import Dialog from "../../../../../../common/element/Dialog";

const ViewAssignment = ({ dialogOpen, onDialogClose, sessionData, questionsData = [] }) => {
  const questionsList = sessionData?.questions || questionsData || [];

  return (
    <Dialog isOpen={dialogOpen} onClose={onDialogClose} width={650}>
      {/* Header */}
      <div className="flex border-b border-gray-100 px-6 py-4 items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="h-9 w-9 border rounded-md border-gray-200 flex items-center justify-center text-gray-500 shadow-sm">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="9" x2="15" y2="9"></line>
              <line x1="9" y1="13" x2="15" y2="13"></line>
              <line x1="9" y1="17" x2="12" y2="17"></line>
            </svg>
          </span>
          <h5 className="font-sans font-semibold text-[16px] text-[#111827]">View Assignment</h5>
        </div>
        <button onClick={onDialogClose} className="text-gray-400 hover:text-gray-600 transition-colors">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="px-3 py-5 overflow-y-auto" style={{ maxHeight: "calc(90vh - 140px)" }}>
        {/* Assignment Name */}
        <h4 className="font-semibold text-[16px] text-[#111827] mb-5 bg-[#FFF4E5] p-4 rounded-md">
          {sessionData?.assignment_name || "Assignment"}
        </h4>

        {/* Questions List */}
        <div className="flex flex-col gap-5">
          {questionsList.map((question, index) => {
            const qText = question.question_text || question.question;
            const subQuestions = question.sub_questions || [];
            const answersArray = question.answers || [];
            const isWithSub = question.question_type === "with_sub" && subQuestions.length > 0;
            const simpleAnswerText = !isWithSub && (answersArray[0]?.answer_text || question.submitted_answer?.answer_text);

            return (
              <div key={question.question_id || `q${index}`} className="flex flex-col border-b border-gray-200 pb-5">
                <p className="text-[14px] font-medium leading-relaxed text-[#374151]">
                  Q{index + 1}. {qText}
                </p>

                {isWithSub ? (
                  <div className="flex flex-col gap-3 mt-2 ml-4">
                    {subQuestions.map((sub, subIndex) => {
                      const subAnswerText = answersArray.find(a => a.sub_question_index === subIndex)?.answer_text;
                      return (
                        <div key={subIndex}>
                          <p className="text-[13px] text-[#374151] leading-relaxed mb-1">
                            {String.fromCharCode(97 + subIndex)}. {typeof sub === "string" ? sub : sub?.sub_question_text || sub?.text || ""}
                          </p>
                          {subAnswerText && (
                            <div className="px-3 py-2.5 bg-[#F9FAFB] border border-gray-200 rounded-md">
                              <p className="text-[14px] text-gray-800 whitespace-pre-wrap">{subAnswerText}</p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  simpleAnswerText && (
                    <div className="mt-2 px-3 py-2.5 bg-[#F9FAFB] border border-gray-200 rounded-md">
                      <p className="text-[14px] text-gray-800 whitespace-pre-wrap">{simpleAnswerText}</p>
                    </div>
                  )
                )}
              </div>
            );
          })}
          {questionsList.length === 0 && (
            <p className="text-[14px] text-gray-500 text-center py-4">No questions available.</p>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-100 flex justify-end">
        <button
          onClick={onDialogClose}
          className="px-5 py-2 rounded-lg bg-white border border-gray-200 text-[#374151] text-[14px] font-medium hover:bg-gray-50 transition-colors shadow-sm"
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default ViewAssignment;
